import { createFileRoute, redirect } from '@tanstack/react-router';

import { Home } from '@/components/features/home/Home';
import { DEFAULT_TENANT_ID } from '@/constants';

export const Route = createFileRoute('/_protected/')({
  ssr: true,
  beforeLoad: ({ context: { tenantId } }) => {
    if (tenantId && tenantId !== DEFAULT_TENANT_ID) {
      throw redirect({ to: '/t/$tenantId', params: { tenantId }, replace: true });
    }
  },
  component: Home,
});
